import gql from 'graphql-tag';
import { locationFieldsFragment } from './locationFieldsFragment';
import { participantFieldsFragment } from './participantFieldsFragment';
import { sanityDocumentFieldsFragment } from './sanityDocumentFieldsFragment';
import { sessionFieldsFragment } from './sessionFieldsFragment';

// @TODO create more summary fragments
export const scheduledSessionSummaryFieldsFragment = gql`
  fragment AdminScheduledSessionSummaryFields on ScheduledSession {
    ... on SanityDocument {
      ...AdminSanityDocumentFields
    }
    status
    assignedUser
    session { _ref }
    location { _ref }
    datetime
    loginCode
    reference
    participants { _ref }
    options {
      allQuestionsInEvaluationShownByDefault
      enableAutoPauseOnHelpRequest
    }
    rSession {
      ... on SanityDocument {
        ...AdminSanityDocumentFields
      }
      name
      categories { _ref }
      rCategories {
        ... on SanityDocument {
          ...AdminSanityDocumentFields
        }
        name
      }
    }
    rLocation { ...AdminLocationFields }
    rParticipants {
      ... on SanityDocument {
        ...AdminSanityDocumentFields
      }
      externalId
      name
      email
      phone
    }
  }

  ${sanityDocumentFieldsFragment}
  ${sessionFieldsFragment}
  ${locationFieldsFragment}
  ${participantFieldsFragment}
`;